/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

import { createSlice, createSelector } from '@reduxjs/toolkit'

export const initialState = {
  errorPage: {
    isDisplayed: false,
  },
  isPostScanActionDrawerOpen: false,
}

function setActiveErrorPageAction(state: Redux.UIState) {
  state.errorPage.isDisplayed = true
}

function toggleIsPostScanActionDrawerOpenAction(state: Redux.UIState) {
  state.isPostScanActionDrawerOpen = !state.isPostScanActionDrawerOpen
}

function resetUIAction() {
  return initialState
}

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setActiveErrorPage: setActiveErrorPageAction,
    toggleIsPostScanActionDrawerOpen: toggleIsPostScanActionDrawerOpenAction,
    resetUI: resetUIAction,
  },
})

export const selectSelf = (state: Redux.RootState) => state.ui

export const isErrorPageActiveSelector = createSelector(
  selectSelf,
  ui => ui.errorPage.isDisplayed
)

export const isPostScanActionDrawerOpenSelector = createSelector(
  selectSelf,
  ui => ui.isPostScanActionDrawerOpen
)

export const { setActiveErrorPage, toggleIsPostScanActionDrawerOpen, resetUI } =
  uiSlice.actions

export default uiSlice.reducer
